import React, { useState, useMemo } from "react";
import "../UIcss/Animations.css";
import { FaCode, FaMagic } from "react-icons/fa";
import { LuCopy, LuInfo } from "react-icons/lu";
import Pagination from "./Pagination.jsx";
import CodeViewer from "./CodeViewer.jsx";
import { animationData } from "./animationData.js";
// --- HELPER TO GET CODE ---
const getGeneratedCode = (anim) => {
  const htmlCode = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${anim.name} - CodePulse UI</title>
    <link href="https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap" rel="stylesheet">
    <style>
        body { 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            margin: 0; 
            font-family: 'Orbitron', sans-serif;
            background: #0c0c0c;
            height: 100vh;
        }
        
        /* Animation Styles */
        ${anim.css}
    </style>
</head>
<body>
    ${anim.html}
</body>
</html>`;

  return { html: htmlCode, css: anim.css };
};

const AnimationRenderer = ({ anim, onViewCode }) => {
  return (
    <div className="animation-item-container">
      <div className="animation-meta-header">
        <span className="anim-label">{anim.name.split(" - ")[0]}</span>
        <button
          className="animation-copy-btn"
          onClick={(e) => {
            e.stopPropagation();
            onViewCode(anim);
          }}
        >
          <LuCopy />
        </button>
      </div>

      <div className="animation-preview-area">
        <div className={`animation-preview anim-${anim.id}`}>
          <div className="anim-shape"></div>
        </div>
      </div>

      <div className="animation-footer-info">
        <span className="anim-id-tag">{anim.id}</span>
        <span className="anim-details-text">{anim.details}</span>
      </div>
    </div>
  );
};

const Animations = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;
  const totalItems = 200;

  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeAnim, setActiveAnim] = useState(null);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleViewCode = (anim) => {
    setActiveAnim(anim);
    setViewerOpen(true);
  };

  const currentItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return animationData.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage]);

  const generatedCode = useMemo(() => {
    if (!activeAnim) return { html: "", css: "" };
    return getGeneratedCode(activeAnim);
  }, [activeAnim]);

  return (
    <div className="animations-page-wrapper">
      <div className="library-header">
        <div className="header-content">
          <h1>
            <FaMagic /> Animations <span>Library</span>
          </h1>
          {/* <p>Explore 200+ premium CSS animations for your modern web projects.</p> */}
        </div>
      </div>

      <div className="animations-grid">
        {currentItems.map((anim) => (
          <AnimationRenderer
            key={anim.id}
            anim={anim}
            onViewCode={handleViewCode}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalItems / itemsPerPage)}
        onPageChange={handlePageChange}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
      />

      {viewerOpen && activeAnim && (
        <CodeViewer
          isOpen={viewerOpen}
          onClose={() => setViewerOpen(false)}
          componentName={activeAnim.name}
          jsxCode={generatedCode.html}
          cssCode={generatedCode.css}
        />
      )}
    </div>
  );
};

export default Animations;
